
































































import { Component } from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';
import { RuleDecl } from 'vue/types/options';
import { State } from 'vuex-class';
import Location from '@/services/Location';
import Vue from 'vue';

@Component({
	components: {},
})
export default class LocationHeader extends Vue {
	@State('location') location!: Location;
	validations(): RuleDecl {
		const atLeastOne = () => {return this.location.hasAtm || this.location.isBrick};
		return {
			location: {
				title: {
					required
				},
				isBrick: { custom: atLeastOne },
				hasAtm: { custom: atLeastOne },
				enabled: {}
			}
		}
	}

	get titleErrors() {
		return this.$v.location.title?.$error ? 'Name is required. Please complete this field.' : '';
	}

	get hasBranchError() {
		return (this.$v.location.isBrick?.$error || this.$v.location.hasAtm?.$error);
	}

}
